import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LessonDemo, PaginationDemo} from "../../../types/lessons/lessons-demo/lessonsDemoSchema";

interface LessonsDemoState {
    items: LessonDemo[];
    pagination: PaginationDemo;
    isLoading: boolean;
    error: string | null;
    successSingUpMeeting: boolean
    subscribedLessonId: number | null
    successSingOffMeeting: boolean
}


const initialState: LessonsDemoState = {
    items: [],
    isLoading: true,
    pagination: {} as PaginationDemo,
    error: null,
    successSingUpMeeting: false,
    subscribedLessonId: null,
    successSingOffMeeting: false,
};

const lessonsDemoSlice = createSlice({
    name: "lessonsDemo",
    initialState,
    reducers: {
        setLessonsDemo: (state, action) => {
            const {items} = action.payload;
            state.items = items;
            state.isLoading = false;
            state.error = null;
            state.pagination = action.payload.pagination;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setErrorDemo: (state, action) => {
            state.error = action.payload;
        },
        setResponseSubscribedLessonId: (state, action) => {
            state.subscribedLessonId = action.payload;
        },
        setResponseSingOffMeeting: (state, action) => {
            state.successSingOffMeeting = action.payload;
        },
    },

});


export const {
    setLessonsDemo,
    setResponseSubscribedLessonId,
    setResponseSingOffMeeting,
    setLoading,
} = lessonsDemoSlice.actions;
export const lessonsDemoReducer = lessonsDemoSlice.reducer;


